import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  readonly rootURL = environment.apiurl+"payment/";

  constructor(private http: HttpClient) { }
  
  
  buyPlan(data:any):any {
    return this.http.post(this.rootURL+`buycredit`,data).toPromise();
  }
 
  getPaymentHistory(email:any):any {
    return this.http.get(this.rootURL+`paymenthistory?email=${email}`).toPromise();
  }
  checkPaymentHistory(paymentid:any){
    return this.http.post(this.rootURL+`checkpayment`,paymentid).toPromise();
  }
}
